import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_ANNOUNCEMENT_REQUEST = 'Announcement/FETCH_ANNOUNCEMENT_REQUEST'
const FETCH_ANNOUNCEMENT_SUCCESS = 'Announcement/FETCH_BRAND_NEWS_SUCCESS'
const FETCH_ANNOUNCEMENT_FAILURE = 'Announcement/FETCH_BRAND_NEWS_FAILURE'

const FETCH_ANNOUNCEMENT_BY_ID_REQUEST =
  'Announcement/FETCH_ANNOUNCEMENT_BY_ID_REQUEST'
const FETCH_ANNOUNCEMENT_BY_ID_SUCCESS =
  'Announcement/FETCH_ANNOUNCEMENT_BY_ID_SUCCESS'
const FETCH_ANNOUNCEMENT_BY_ID_FAILURE =
  'Announcement/FETCH_ANNOUNCEMENT_ID_FAILURE'

const CREATE_ANNOUNCEMENT_REQUEST = 'Announcement/CREATE_ANNOUNCEMENT_REQUEST'
const CREATE_ANNOUNCEMENT_SUCCESS = 'Announcement/CREATE_ANNOUNCEMENT_SUCCESS'
const CREATE_ANNOUNCEMENT_FAILURE = 'Announcement/CREATE_ANNOUNCEMENT_FAILURE'

const UPDATE_ANNOUNCEMENT_REQUEST = 'Announcement/UPDATE_ANNOUNCEMENT_REQUEST'
const UPDATE_ANNOUNCEMENT_SUCCESS = 'Announcement/UPDATE_ANNOUNCEMENT_SUCCESS'
const UPDATE_ANNOUNCEMENT_FAILURE = 'Announcement/UPDATE_ANNOUNCEMENT_FAILURE'

const DELETE_ANNOUNCEMENT_REQUEST = 'Announcement/DELETE_ANNOUNCEMENT_REQUEST'
const DELETE_ANNOUNCEMENT_SUCCESS = 'Announcement/DELETE_ANNOUNCEMENT_SUCCESS'
const DELETE_ANNOUNCEMENT_FAILURE = 'Announcement/DELETE_ANNOUNCEMENT_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  announcementList: [],
  announcementObj: {}
}

// Default Reducer
const announcement = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        announcementList: action.payload
      }
    case FETCH_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_ANNOUNCEMENT_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ANNOUNCEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        announcementObj: action.payload
      }
    case FETCH_ANNOUNCEMENT_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default announcement

// Action Creators
export const fetchAnnouncementList = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_ANNOUNCEMENT_REQUEST
      })

      const response = await API.get(EndPoints.ANNOUNCEMENT, {
        params: options
      })
      dispatch({
        type: FETCH_ANNOUNCEMENT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_ANNOUNCEMENT_FAILURE
      })
    }
  }
}

export const createAnnouncement = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_ANNOUNCEMENT_REQUEST
      })

      await API.post(EndPoints.ANNOUNCEMENT, data)
      dispatch({
        type: CREATE_ANNOUNCEMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_ANNOUNCEMENT_FAILURE
      })
    }
  }
}

export const updateAnnouncement = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_ANNOUNCEMENT_REQUEST
      })

      await API.put(EndPoints.ANNOUNCEMENT, data)
      dispatch({
        type: UPDATE_ANNOUNCEMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_ANNOUNCEMENT_FAILURE
      })
    }
  }
}

export const deleteAnnouncement = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_ANNOUNCEMENT_REQUEST
      })

      await API.delete(EndPoints.ANNOUNCEMENT + `/${id}`)
      dispatch({
        type: DELETE_ANNOUNCEMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_ANNOUNCEMENT_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/announcement.js